import React from "react";
import { Icon, theme } from "uikit";

import { StyledP, StyledRow } from "../../../common";

const Button: React.FC<Button.Props> = ({ icon, label, onClick, disabled }) => (
	<StyledRow
		alignItems="center"
		gap="5px"
		cursor="pointer"
		onClick={() => {
			if (disabled) return;
			onClick?.();
		}}
	>
		{icon && (
			<Icon
				id={icon}
				size={12}
				colors={
					disabled
						? [theme.colors.disabled_text]
						: [theme.colors.secondary]
				}
			/>
		)}
		<StyledP
			colors={
				disabled ? theme.colors.disabled_text : theme.colors.secondary
			}
		>
			{label}
		</StyledP>
	</StyledRow>
);

declare namespace Button {
	interface Props {
		icon?: Icon.Props["id"];
		label: string;
		disabled?: boolean;
		onClick?: () => void;
	}
}

export default Button;
